// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Moha","colCheckbox":"styles_colCheckbox__7cCjD"};